import React from "react";

export default function Cart() {
  return (
    <div>
      Hello World
    </div>
  );
}
